<template>
  <ais-state-results>
    <template #default="{ results: { query } }">
      <div v-show="query.length == 0">
        <div class="ais-sort-results" data-v-7486f7d7="">
          <div class="ais-SortBy">
            <div class="ais-sort-by">
              <div
                :class="['ais-sort-by-item', topRated ? 'active' : '']"
                @click="ShowTopRated"
              >
                <div class="sort-item">Top Rated</div>
              </div>
              <div v-if="ShowTrendingTab"
                :class="['ais-sort-by-item', trending ? 'active' : '']"
                @click="ShowTrending"
              >
                <div class="sort-item">Trending</div>
              </div>
              <div v-if="ShowOffersTab"
                :class="['ais-sort-by-item', offers ? 'active' : '']"
                @click="ShowOffers"
              >
                <div class="sort-item">Offers</div>
              </div>
            </div>
          </div>
        </div>
        <div class="frame-section">
        <div class="ais-InfiniteHits-list">
          <div
            class="ais-InfiniteHits-item"
            v-for="item in this.merchantList"
            :key="item.id"
          >
            <a :href="'/m/merchant/' + item.id">
              <div class="rectangle-group" :style="groupDivStyle">
                <img class="frame-inner" alt="" :src="rectangle3" />

                <img
                  v-if="item.rectBannerUrl == null"
                  :src="item.rectBannerLink"
                  class="rectangle-div"
                />
                <img
                  v-else
                  :src="item.rectBannerUrl.formats.thumbnail.url"
                  class="rectangle-div"
                />

                <div class="up-to-off-instance">
                  <div
                    :class="[
                      item.merchantDiscount && isDiscountValid(item.discountStartDate, item.discountEndDate)
                        ? 'shopping-bag-instance'
                        : 'shopping-bag-instance-blank',
                    ]"
                  >
                    <b class="up-to-40" v-if="isDiscountValid(item.discountStartDate, item.discountEndDate)">
                      {{ item.merchantDiscount }}
                    </b>
                  </div>
                </div>
                <div class="stripes-checks-instance"></div>
                <div class="frame-parent14">
                  <div class="frame-wrapper9">
                    <div class="shopping-bag-parent">
                      <img
                        class="shopping-bag-icon"
                        alt=""
                        src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Koko-search/Shopping%20Bag.png"
                      />
                      <div class="instore-online">
                        <div
                          class="instore-online-child"
                          v-if="item.doesOffline"
                        >
                          Instore
                        </div>
                        <div
                          class="instore-online-child"
                          v-if="
                            item.doesOnline &&
                            item.doesSocial &&
                            item.doesOffline
                          "
                        >
                          ,
                        </div>
                        <div
                          class="instore-online-child"
                          v-if="
                            item.doesOnline &&
                            !item.doesSocial &&
                            item.doesOffline
                          "
                        >
                          &
                        </div>
                        <div
                          class="instore-online-child"
                          v-if="item.doesOnline"
                        >
                          Online
                        </div>
                        <div
                          class="instore-online-child"
                          v-if="
                            (item.doesOnline &&
                              item.doesSocial &&
                              item.doesOffline) ||
                            (!item.doesOnline &&
                              item.doesSocial &&
                              item.doesOffline) ||
                            (item.doesOnline &&
                              item.doesSocial &&
                              !item.doesOffline)
                          "
                        >
                          &
                        </div>
                        <div
                          class="instore-online-child"
                          v-if="item.doesSocial"
                        >
                          Social Media
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rectangle-container">
                    <div class="frame-child1" />

                    <div class="stripes-checks">{{ item.merchantName }}</div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div v-if="merchantList.length>=6"
         class="ais-InfiniteHits-loadMore" @click="loadMoreResults">
          Show more results
        </div>
    </div>
      </div>
    </template>
  </ais-state-results>
</template>

<script>
import Strapi from "../services/strapi-services";
import { AisStateResults } from 'vue-instantsearch/vue3/es';
import { isDiscountValid } from '../utils/discountUtils';
const strapi = new Strapi();
export default {
  props: ["AllMerchantsProp"],
  components:{
    AisStateResults
  },
  data() {
    return {
      merchantList: [],
      topRated: true,
      trending: false,
      offers:false,
      tabName: "searchRankOverall",
      TopRatedCurrentPage: 1,
      TrendingCurrentPage: 1,
      OffersCurrentPage: 1,
      ShowTrendingTab:false,
      ShowOffersTab:false,
      
    };
  },
  created() {
    this.GetAllMerchantsByTag(this.tabName, this.TopRatedCurrentPage);
    this.GetAllsiteSettings();
  },
  methods: {
    isDiscountValid,
    ShowTopRated() {
      this.topRated = true;
      this.trending = false;
      this.offers = false,
      this.tabName = "searchRankOverall";
      this.GetAllMerchantsByTag(this.tabName, this.TopRatedCurrentPage);
    },
    ShowTrending() {
      this.topRated = false;
      this.trending = true;
      this.offers = false,
      this.tabName = "searchRank30Days";
      this.GetAllMerchantsByTag(this.tabName, this.TrendingCurrentPage);
    },
    ShowOffers() {
      this.topRated = false;
      this.trending = false;
      this.offers = true,
      this.tabName = "discountValue";
      this.GetAllMerchantsByTag(this.tabName, this.OffersCurrentPage);
    },
    GetAllMerchantsByTag(tabName, currentPage) {
      strapi
        .getMerchants(tabName, currentPage)
        .then((res) => {
          this.merchantList = res.data;
          this.stripBanner = true;
        })
        .catch((error) => {
          console.log("merchants", error);
        });
    },

    loadMoreResults() {
      if (this.topRated) {
        this.TopRatedCurrentPage++;
        this.GetAllMerchantsByTag(this.tabName, this.TopRatedCurrentPage);
      } else if(this.trending){
        this.TrendingCurrentPage++;
        this.GetAllMerchantsByTag(this.tabName, this.TrendingCurrentPage);
      }else{
        this.OffersCurrentPage++;
        this.GetAllMerchantsByTag(this.tabName, this.OffersCurrentPage)
      }
    },
    GetAllsiteSettings() {
      strapi
        .getOnsiteSettings()
        .then((res) => {
          this.onsiteSettings = res.data[0];
          this.ShowOffersTab = this.onsiteSettings.Offers_tab_enable;
          this.ShowTrendingTab = this.onsiteSettings.Trending_tab_enable;
          
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style>
  a{
  text-decoration: none;
}
</style>